import { createStore } from 'satcheljs';
import FormsDiagnosticsStore from './schema/FormsDiagnosticsStore';

export default createStore<FormsDiagnosticsStore>('FormsDiagnosticsStore', {
    serviceCalls: [],
    selectedServiceCallIndex: -1,
});
